import React from 'react';

export const APK_FILE_NAME = '7966.apk';
export const APP_ICON_URL = '/downloads/gainbox-icon.png';

export const downloadPageStyles = {
  page: {
    minHeight: '100%',
    background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
    padding: '22px 18px 30px',
    boxSizing: 'border-box',
  } as React.CSSProperties,
  shell: {
    width: '100%',
    maxWidth: 480,
    margin: '0 auto',
  } as React.CSSProperties,
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 20,
  } as React.CSSProperties,
  versionBadge: {
    minHeight: 32,
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '0 12px',
    background: '#111827',
    color: '#f9fafb',
    fontSize: 12,
    fontWeight: 700,
  } as React.CSSProperties,
  localeSwitcher: {
    minWidth: 112,
    minHeight: 38,
    padding: '0 12px',
    fontSize: 12,
    boxShadow: '0 8px 18px rgba(15, 23, 42, 0.06)',
  } as React.CSSProperties,
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '8px 0 24px',
  } as React.CSSProperties,
  icon: {
    width: 112,
    height: 112,
    borderRadius: 28,
    boxShadow: '0 18px 36px rgba(15, 23, 42, 0.22)',
    marginBottom: 18,
  } as React.CSSProperties,
  title: {
    margin: 0,
    fontSize: 34,
    lineHeight: 1.1,
    fontWeight: 800,
    color: '#111827',
  } as React.CSSProperties,
  tagline: {
    marginTop: 12,
    maxWidth: 360,
    fontSize: 17,
    lineHeight: 1.45,
    fontWeight: 800,
    color: '#1f2937',
  } as React.CSSProperties,
  subtitle: {
    marginTop: 8,
    maxWidth: 340,
    fontSize: 15,
    lineHeight: 1.6,
    color: '#4b5563',
  } as React.CSSProperties,
  actionStack: {
    display: 'grid',
    gap: 12,
    marginTop: 8,
  } as React.CSSProperties,
  primaryButton: {
    '--border-radius': '18px',
    height: 52,
    fontSize: 16,
    fontWeight: 800,
    boxShadow: '0 16px 30px rgba(245, 158, 11, 0.26)',
  } as React.CSSProperties,
  secondaryButton: {
    '--border-radius': '18px',
    height: 50,
    fontSize: 15,
    fontWeight: 700,
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    color: '#111827',
  } as React.CSSProperties,
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 10,
    marginTop: 22,
  } as React.CSSProperties,
  infoItem: {
    minHeight: 72,
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    padding: '12px 10px',
    boxSizing: 'border-box',
  } as React.CSSProperties,
  infoLabel: {
    fontSize: 11,
    lineHeight: 1.3,
    color: '#6b7280',
    marginBottom: 6,
  } as React.CSSProperties,
  infoValue: {
    fontSize: 13,
    lineHeight: 1.35,
    color: '#111827',
    fontWeight: 800,
  } as React.CSSProperties,
  notice: {
    marginTop: 18,
    borderRadius: 20,
    background: '#fffbeb',
    color: '#92400e',
    border: '1px solid #fde68a',
    padding: '14px 14px',
    fontSize: 13,
    lineHeight: 1.55,
  } as React.CSSProperties,
  privacyNotice: {
    marginTop: 18,
    borderRadius: 20,
    background: '#f0f9ff',
    color: '#0f3f5f',
    border: '1px solid #bae6fd',
    padding: '14px 14px',
    fontSize: 13,
    lineHeight: 1.6,
  } as React.CSSProperties,
  errorNotice: {
    marginTop: 18,
    borderRadius: 20,
    background: '#fef2f2',
    color: '#991b1b',
    border: '1px solid #fecaca',
    padding: '14px 14px',
    fontSize: 13,
    lineHeight: 1.55,
  } as React.CSSProperties,
};
